import React from 'react'
import { Layout } from 'antd'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import { FlexColumn, FlexRow } from './FlexboxReusables/FlexItems'

const { Footer } = Layout

const FooterContent: React.FC<{isDarkMode: boolean}> = ({ isDarkMode }) => {
  const currentYear = new Date().getFullYear()

  return (
    <FooterWrapper
      isDarkMode={isDarkMode}
    >   
      <FlexRow width='100%'>
        <FlexColumn width='50%'>
            ©{currentYear} - ET360 GmbH
        </FlexColumn>
        <FlexColumn width='50%'>
          <Link to='/imprint'>
            <FormattedMessage description='imprint' id='generic.imprint' />
          </Link>
        </FlexColumn>
      </FlexRow>
    </FooterWrapper>
  )
}

export default FooterContent

const FooterWrapper = styled(Footer)<{ isDarkMode: boolean}>`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2vh;
  border-top: 1px solid #e8e8e8;
  background-color: ${(props) => (props.isDarkMode ? "#1f1f1f !important" : "white !important")};
`